import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Banner = () => {
	const { i18n } = useTranslation();
	const [bannerContent, setBannerContent] = useState(null);
	const apiUrl = `/rest/v1/wp-banner?lang=${i18n.language}`;

	useEffect(() => {
		axios.get(apiUrl)
			.then(response => {
				if (response.data.acf) {
					setBannerContent(response.data.acf);
				}
			})
			.catch(error => {
				console.error('Error fetching banner content');
			});
	}, [apiUrl]);

	if (!bannerContent) {
		return <div></div>;
	}

	return (
		<a href={bannerContent.lien} className="banner" target="_blank" rel="noopener noreferrer"
		   style={{ textDecoration: 'none' }}>
			<div>
				<img src={`/rest/v1/wp-banner/image?url=${encodeURIComponent(bannerContent.image_desktop)}`} alt="Banner Desktop"  className="desktop-img" />
				<img src={`/rest/v1/wp-banner/image?url=${encodeURIComponent(bannerContent.image_mobile)}`} alt="Banner Mobile" className="mobile-img" />
			</div>
		</a>
	);
};

export default Banner;
